<div *ngIf="productList">
  <div *ngFor="let product of productList">
    <div class="product-card">
      <div class="d-flex">
        <div class="product-avatar">
          <img class="product-image" src="{{ product?.image }}" />
        </div>
        <div class="product-details">
          <h3>{{ product.title }}</h3>
          <div class="product-regions">
            <p>Regions: &nbsp;</p>
            <p *ngFor="let region of product.regions">{{ region.name }},&nbsp;</p>
          </div>
        </div>
      </div>
      <div class="product-info">
        <h3 *ngIf="!product.hide_range">
          {{ product.title }} {{ product.currency.symbol
          }}{{ product.price_min
          }}<span *ngIf="product.price_min != product.price_max">
            - {{ product.currency.symbol }}{{ product.price_max }},&nbsp;</span
          >
          <span>
               Product Code: <b>{{ product.product_code }}</b>
          </span>
        </h3>

        <div *ngFor="let suggestion of product.suggestions">
          <h3>
            {{ product.title }} {{ suggestion.title }}
            {{ product.currency.symbol }}{{ suggestion.price }},&nbsp;
            <span>
              Product Code: <b>{{ suggestion?.product_code || product.product_code }}</b>
            </span>
          </h3>
        </div>
      </div>
      <hr />
      <div>
        <ng-container *ngIf="product.marketing">
          <h4><b>Product Description</b></h4>
          <div [innerHTML]="product.marketing"></div>
        </ng-container>
        <ng-container *ngIf="product.legal_disclaimer">
          <h4><b>Legal Disclaimer</b></h4>
          <div [innerHTML]="product.legal_disclaimer"></div>
        </ng-container>
        <ng-container *ngIf="product.redeem">
          <h4><b>Redemption Instruction</b></h4>
          <div [innerHTML]="product.redeem"></div>
        </ng-container>
        <ng-container *ngIf="product.term">
          <h4><b>Terms and Conditions</b></h4>
          <div [innerHTML]="product.term"></div>
        </ng-container>
      </div>
      <!-- <div class="product-card" *ngFor="let suggestion of product.suggestions">
            <div class="d-flex">
                <div class="product-avatar">
                    <img class="product-image" src="{{ product.image }}">
                    <p>UPC: <b>{{ suggestion.upc || product.upc }}</b></p>
                </div>
                <div class="product-info">
                    <h3>
                        <b>
                            {{ product.title }} {{suggestion.title}} {{product.currency_data.symbol}}{{suggestion.price}}
                        </b>
                    </h3>
                    <div [innerHTML]="getProductDescription(product)"></div>
                </div>
            </div>
        </div> -->
    </div>
  </div>
</div>
